import React, { Component } from 'react';
import { OrganizationFieldInput } from '../organization-field-renderer';

class LikertFieldInput extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fieldValue: props.initialValue || { value: '', optionId: null, multipleIds: [], likertAnswers: {} }
    };
  }

  handleChange = (value) => {
    this.setState({ fieldValue: value });
    if (this.props.onChange)
      this.props.onChange(value);
  }

  render() {
    return (
      <OrganizationFieldInput
        field={this.props.field}
        value={this.state.fieldValue}
        onChange={this.handleChange}
        disabled={this.props.disabled}
        required={this.props.required}
        likertCardLayout={this.props.likertCardLayout} />
    );
  }
}

export default LikertFieldInput;
